import { NotImplementedError } from '../exceptions/NotImplementedError';
import { Application } from './lib/application';

const app$ = Application.getInstance();

export function app<T = any>($class?: any, ...args: any): T {
    if ($class) {
        if (typeof $class === 'string') {
            if (args.length > 0) {
                const [value, ...rest] = args;

                if (typeof value === 'function') {
                    return app$.bind($class, value, ...rest);
                }
            }

            if (!app$.hasService($class)) {
                throw new NotImplementedError(`Un-registered service '${$class}'`);
            }

            return app$.getService<T>($class);
        }

        return app$.make<T>($class, ...args);
    }

    return app$ as any;
}
